module.exports = __webpack_public_path__ + "static/media/romanticos_masculino_acessorios.668dcfd6.jpg";